import {detailOfferListConstraints} from "../constants/detail_offer_list_constraints";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {OfferType} from "../types/OfferType";

interface IGetDetailPageNearbyOffersParams {
    id: number;
    type: OfferType;
    region: {
        id: number;
    };
}

export function getDetailPageNearbyOffersPayload(offer: IGetDetailPageNearbyOffersParams): IGetOfferListPayload {
    return {
        page: 1,
        page_size: 20,
        ...detailOfferListConstraints,
        type: offer.type === OfferType.COMMERCIAL ? OfferType.COMMERCIAL : [OfferType.FLAT, OfferType.HOUSE],
        region: offer.region.id,
        exclude_offer: offer.id
    };
}
import {detailOfferListConstraints} from "../constants/detail_offer_list_constraints";
import {IGetOfferListPayload} from "../types/GetOfferListPayload";
import {OfferType} from "../types/OfferType";

interface IGetDetailPageNearbyOffersParams {
    id: number;
    type: OfferType;
    region: {
        id: number;
    };
}

export function getDetailPageNearbyOffersPayload(offer: IGetDetailPageNearbyOffersParams): IGetOfferListPayload {
    return {
        page: 1,
        page_size: 20,
        ...detailOfferListConstraints,
        type: offer.type === OfferType.COMMERCIAL ? OfferType.COMMERCIAL : [OfferType.FLAT, OfferType.HOUSE],
        region: offer.region.id,
        exclude_offer: offer.id
    };
}
